import { render, staticRenderFns } from "./revoke-customer-tokens-card.vue?vue&type=template&id=5b10fdca&scoped=true"
import script from "./revoke-customer-tokens-card.vue?vue&type=script&lang=js"
export * from "./revoke-customer-tokens-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10fdca",
  null
  
)

export default component.exports